export default __webpack_public_path__ + "static/media/manheim-logo-2-hi-res.183120c4.png";